// eslint-disable-next-line
import {
  getHoles,
  getSensorsByHole,
  getRssiRanges,
  getZones,
  getSensorsByZone,
} from '@/api/index';
import { Mixin } from 'gw-js-lib';

export default {
  namespaced: true,
  state() {
    return ({
      holes: [],
      rssiRanges: [],
      loading: {
        holes: false,
        sensors: false,
      },
      holeSelected: {
        sensors: [],
      },
      sensors: [],
      zones: [],
      zoneSelected: {
        sensors: [],
      },
    });
  },
  getters: {},
  mutations: {
    setRssiRanges(state, rssiRanges) {
      state.rssiRanges = rssiRanges;
    },
    setHoleSelected(state, hole) {
      state.holeSelected = hole;
      state.holeSelected.sensors = [];
    },
    setSensors(state, sensors) {
      if(state.holeSelected && state.holeSelected.hole_id){
        state.holeSelected.sensors = sensors;
      }
      if(state.zoneSelected && state.zoneSelected.zone_id){
        state.zoneSelected.sensors = sensors;
      }
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven();}, 10);
    },
    setHoles(state, holes) {
      state.holes = holes;
    },
    setLoadingHoles(state, status) {
      state.loading.holes = status;
    },
    setLoadingSensors(state, status) {
      state.loading.sensors = status;
    },
    setZoneSelected(state, zone) {
      state.zoneSelected = zone;
      state.zoneSelected.sensors = [];
    },
    setZoneSensors(state, sensors) {
      state.zoneSelected.sensors = sensors;
      setTimeout(()=> { Mixin.methods.G_triggerResizeEven();}, 10);
    },
    setZones(state, zones) {
      state.zones = zones;
    },
  },
  actions: {
    async apiGetHoles({
      commit,
      state,
      dispatch,
    }) {
      if (state.holes.length === 0) {
        commit('setLoadingHoles', true);
      }
      await getHoles().then(async (res) => {
        commit('setHoles', res.holes ? res.holes : []);
        commit('setLoadingHoles', false);
        if (res.holes && res.holes.length) {
          await dispatch('apiGetSensorByHole', res.holes[0]);
        }
      });
      if (Mixin.methods.G_isEmptyArr(state.rssiRanges)) {
        getRssiRanges().then((rssiRanges) => {
          commit('setRssiRanges', rssiRanges);
        });
      }
    },

    async apiGetSensorByHole({
      commit,
    }, hole) {
      commit('setZoneSelected', {});
      commit('setHoleSelected', hole);
      commit('setLoadingSensors', true);
      await getSensorsByHole(hole.hole_id).then((res) => {
        if (res.sensors) {
          const sensorList = res.sensors.map((s) => ({
            ...s,
            lat: parseFloat(s.latitude),
            lng: parseFloat(s.longitude),
          }));
          commit('setSensors', sensorList);
        }
      });
      commit('setLoadingSensors', false);
    },

    async apiGetZones({
      commit,
      state,
      dispatch,
    }, course_id) {
      await getZones().then(async (res) => {
        commit('setZones', []);
        let zones = res.zones.filter(x => x.show_sensors);

        commit('setZones', zones ? zones : []);

        if (zones && zones.length) {
          for (let zone of zones) {
            await dispatch('apiGetAssociatedSensors', {course_id, zone});
          }
        }
        commit('setLoadingHoles', false);
      });
    },

    async apiGetAssociatedSensors({
      commit,
      state,
    }, {course_id, zone}) {
      await getSensorsByZone(course_id, zone.zone_id).then((res) => {
        
        const zone_index = state.zones.findIndex(x => x.zone_id == zone.zone_id )

        if (zone_index > -1) {
          let newZones = [...state.zones];
          if (res.sensors && res.sensors.length > 0) {
            newZones[zone_index] = {...newZones[zone_index], ...{sensor_linked: true} };
          } else {
            newZones[zone_index] = {...newZones[zone_index], ...{sensor_linked: false} };
          }
          
          commit('setZones', newZones);
        }
      });
    },

    async apiGetSensorByZone({
      commit,
    }, {course_id, zone}) {

      commit('setHoleSelected', {});
      commit('setZoneSelected', zone);
      commit('setLoadingSensors', true);
      await getSensorsByZone(course_id, zone.zone_id).then((res) => {
        if (res.sensors) {
          const sensorList = res.sensors.map((s) => ({
            ...s,
            lat: parseFloat(s.latitude),
            lng: parseFloat(s.longitude),
          }));
          commit('setSensors', sensorList);
        }
      });
      commit('setLoadingSensors', false);
    },
  },
};
